const copyLinkToClipboard = () => {
  const copyLinkAnchors = document.querySelectorAll('[data-copy-link-anchor]');

  copyLinkAnchors.forEach((anchor) => {
    anchor.addEventListener('click', copyLink);
  });

  function copyLink(e) {
    e.preventDefault();
    const target = e.currentTarget;

    // `navigator.clipboard` is only available in secure contexts
    if (window.isSecureContext) {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => {
          console.log('URL copied to clipboard');
          target.innerHTML = 'Link copied <i class="icon icon-check"></i>';
        })
        .catch((err) => {
          console.error('Failed to copy URL: ', err);
        });
    } else {
      console.log('Copying link is only available in secure contexts');
    }
  }
};

export default copyLinkToClipboard;
